import { SupabaseClient } from "@supabase/supabase-js";
import { Database } from "../supabase.types";
import { logSupabaseException } from "@punchup/sentry";

/**
 * Reads the opaque `product_metadata` bag a submitting surface stamped onto a
 * video at create time. The pipeline never interprets this — the
 * pipeline-complete dispatcher reads it here and hands it to each product
 * surface, which interprets the keys it cares about.
 *
 * Returns null when unset or on error: every surface action driven by this
 * (e.g. featuring a special) is best-effort and must not block publish.
 */
export async function getVideoProductMetadata(
  supabase: SupabaseClient<Database>,
  videoId: string
): Promise<Record<string, unknown> | null> {
  const { data, error } = await supabase
    .from("videos")
    .select("product_metadata")
    .eq("id", videoId)
    .maybeSingle();

  if (error) {
    logSupabaseException(
      error,
      `Failed to read product_metadata for video ${videoId}`
    );
    return null;
  }

  return (data?.product_metadata as Record<string, unknown> | null) ?? null;
}
